import { render, staticRenderFns } from "./LoginPopUp.vue?vue&type=template&id=35d5bf7f&"
import script from "./LoginPopUp.vue?vue&type=script&lang=js&"
export * from "./LoginPopUp.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports